<template>
    <!-- SVG表現のチェックボックス -->
    <button @click="clicked" :disabled="disabled"
        style="display:flex; align-items:center; gap: 5px; border: none; background:none; padding: 0; margin: 0; outeline: none">

        <svg :disabled="disabled" :checked="value==true || value==1" viewBox="0 0 200 200" :style="`width: ${size}px; height: ${size}px;`">
            <g v-if="value" fill="white">
                <path d="M17.42,109.28 L51.21,67.44 L90.81,118.47 L175.65,18.10 L182.61,24.18 L99.95,170.49 L17.42,109.28 Z"/>
            </g>
        </svg>
        <slot></slot>
    </button>
</template>

<script>
export default {
    props: {
        value: {
            type: [Boolean, Number],
            default: false,
        },
        disabled: {
            default: false,
        },
        size:{
            type: Number,
            default: 14,
        }
    },
    methods: {
        clicked(){
            if(this.$props.disabled) return

            if(typeof this.$props.value == "number"){
                this.$emit('input', this.$props.value==1 ? 0 : 1)
            }else{
                this.$emit('input', !this.$props.value)
            }
        },
    },
}
</script>

<style scoped>
    svg{
        border: 1px solid gray;
        background: white
    }
    svg[checked]{
        color: white;
        border-color: #0b794f;
        background: #0b794f;
    }
    svg[disabled]{
        background: lightgray;
        border-color: lightgray;
    }
</style>